if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"NuOrderFrontend","remotes":[{"alias":"OrderIntents","name":"OrderIntents","entry":"/federated/order-intents/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^1(5[1256789]|6[0123456789]|70|71)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}